import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faCircleCheck, faCircleExclamation, faPowerOff, faUser } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationType, useNotification } from "../../context/NotificationProvider";
import { List, ListItem, ListItemIcon } from "@mui/material";
import { formatDateTime } from "../Pages/Reports/Reports";

interface TopBarProps {
  username: string;
  toggleMenu: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ username, toggleMenu }) => {
  const { onLogout } = useContext(AuthContext)
  const navigate = useNavigate();
  const location = useLocation()

  const { notifications, fetchNotifications, readNotifications } = useNotification()
  const [unreadNotifications, setUnreadNotifications] = useState<NotificationType[]>([])
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const pageMap: Record<string, string> = {
    "/reports": "Report",
    "/users": "Utenti",
    "/consumptions": 'Consumi'
  };
    
  useEffect(()=> {
    setUnreadNotifications(
      notifications.filter(n => n.read === false)
    )
  }, [notifications])

  const handleLogout = async (e: React.FormEvent) => {
      e.preventDefault();
      onLogout();
      navigate('/');    
  };

  const handleReadNotification = (notificationId: number) => {
    readNotifications([notificationId])
    fetchNotifications()
  }


  return (
    <header className="top-menu main-header">
      <div className="d-flex">
        <button onClick={toggleMenu} className="menu-button p-2" aria-label="Toggle menu">
          <FontAwesomeIcon icon={faBars} />
        </button>
        <h3>
          {
            pageMap[
              Object.keys(pageMap).find((key) =>
                location.pathname.startsWith(key)
              ) || ''
            ] ?? "Generazione"
          }
        </h3>
      </div>
      
      <div className="menu-button" style={{ position: "relative" }}>
        <button
          className="menu-button items-center"
          onClick={()=> {setNotificationsOpen(!notificationsOpen); setIsDropDownOpen(false)}}
        >
          <FontAwesomeIcon icon={faBell} style={{color: '#c50c0f', fontSize: 'larger'}}/>
          <span className="notification-info">
            {unreadNotifications.length !== 0 && unreadNotifications.length}
          </span>
        </button>

        <button
          className="menu-button flex items-center"
          onClick={() => {setIsDropDownOpen(!isDropDownOpen); setNotificationsOpen(false)}}
          aria-haspopup="true"
          aria-expanded={isDropDownOpen}
          aria-label="User menu"
        >
          {username}
          <FontAwesomeIcon icon={faUser} style={{ marginLeft: ".5rem", color: '#c50c0f', fontSize: 'larger' }} />
        </button>

          {notificationsOpen && (
          <div className="notifcations-menu">
            {unreadNotifications.length == 0
            ? <p>
                Non sono presenti nuove notifiche...
              </p>
            : <List sx={{maxHeight: "400px", overflowY:'auto'}}> 
              {unreadNotifications.map(notification => (
                <ListItem 
                  
                  className="clickable"
                  key={notification.id} 
                  onClick={() => handleReadNotification(notification.id)}
                  >
                    <FontAwesomeIcon 
                      icon={notification.kind === 'success' ? faCircleCheck : faCircleExclamation }
                      color={notification.kind === 'success' ? 'var(--toastify-color-success)' : '#c50c0f'}
                      style={{marginRight: '15px'}}
                    />
                      <div>
                        <p>
                          <strong>CUP </strong>{notification.report.cup} - <>{notification.report.company_name}</>
                        </p>
                        <p>{notification.content}</p>
                      </div>
                    <p style={{marginLeft:"30px", fontSize: '12px'}}>{formatDateTime(notification.created_at)}</p>                                   
                </ListItem>
            ))}
          </List>
            }
          </div>
        )}

        {isDropDownOpen && (
          <div className="dropdown-menu">
            <button
              className="d-flex align-items-center"
              onClick={handleLogout}
            >
              <FontAwesomeIcon
                icon={faPowerOff}
                style={{ marginRight: ".5rem", color: "#dc3545", fontSize: "large" }}
              />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopBar;
